import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudService } from './crud.service';

@Injectable({
  providedIn: 'root',
})
export class ApprovedDrugsService extends CrudService {
  constructor(public override http: HttpClient) {
    super('approved-drugs', http);
  }

  /**
   *
   * @param id
   * @returns
   */
  makeUnapproved(id: number) {
    return this.http.get(`${this.baseUrl}/make-unapproved/${id}`);
  }
}
